import { render, staticRenderFns } from "./Modulos.vue?vue&type=template&id=ec5f04ae&scoped=true"
import script from "./Modulos.vue?vue&type=script&lang=js"
export * from "./Modulos.vue?vue&type=script&lang=js"
import style0 from "./Modulos.vue?vue&type=style&index=0&id=ec5f04ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5f04ae",
  null
  
)

export default component.exports